import Button from "components/Button";
import Modal from "components/Modal";
import React from "react";
import { deleteAdmin } from "services/admin";
import ArrowLeft from "icons/arrow-circle-left-green.svg";
import Confirm from "icons/confirm-circle-white.svg";
import toastMessage from "helpers/handleToastMessage";
import { ToastContainer } from "react-toastify";

type Props = {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  deleteId: string;
};

const ModalStatus: React.FC<Props> = ({
  show,
  setShow,
  setLoading,
  deleteId,
}): JSX.Element => {
  const removeAdmin = async () => {
    try {
      setLoading(true);
      await deleteAdmin(deleteId);
    } catch (error: any) {
      toastMessage({
        message: "Error, Something went wrong.",
        type: "error",
      });
    } finally {
      window.location.reload();
      setShow(false);
      setLoading(false);
    }
  };

  return (
    <Modal
      show={show}
      children={
        <div className="w-full h-44 bg-bt-white p-6 rounded-md">
          <div className="flex flex-row items-center justify-center">
            <span className="font-nunito font-light text-xl text-bt-black">
              Do you really want to remove this admin?
            </span>
          </div>
          <div className="flex flex-row justify-around mt-10 mb-10">
            <div className="flex flex-col">
              <Button
                label={"Back"}
                iconLeft={ArrowLeft}
                className="bg-bt-white text-bt-green border border-bt-green h-10 w-28 font-sora rounded-full"
                onClick={() => setShow(false)}
              />
            </div>
            <div className="flex flex-col">
              <Button
                label={"Confirm"}
                iconLeft={Confirm}
                className="bg-bt-green text-bt-white h-10 w-28 font-sora rounded-full"
                onClick={() => removeAdmin()}
              />
            </div>
          </div>
          <ToastContainer />
        </div>
      }
    />
  );
};

export default ModalStatus;
